// extracted by mini-css-extract-plugin
module.exports = {"container":"_25d45facb5--container--s96m6","icon":"_25d45facb5--icon--LIczH"};